var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help_black_24dp",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M18,2A16,16,0,1,0,30.646,27.8,15.724,15.724,0,0,0,34,18a16.181,16.181,0,0,0-2.486-8.565A15.864,15.864,0,0,0,18,2Zm1.6,27.2H16.4V26h3.2Zm3.312-12.4-1.44,1.472a5.6,5.6,0,0,0-1.664,2.7A7.34,7.34,0,0,0,19.6,22.8H16.4V22a6.473,6.473,0,0,1,.352-2.1,6.4,6.4,0,0,1,1.52-2.432l1.984-2.016a3.141,3.141,0,0,0,.88-2.88,3.185,3.185,0,0,0-2.224-2.448A3.226,3.226,0,0,0,14.96,12.16a1.413,1.413,0,0,1-1.312,1.04h-.48a1.386,1.386,0,0,1-1.312-1.792A6.412,6.412,0,0,1,17.024,6.88a6.508,6.508,0,0,1,6.192,2.88A5.291,5.291,0,0,1,22.912,16.8Z",
    fill: "#4385f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.374857f4fb0d223b133707c681bdb0eb.svg";
export { ForwardRef as ReactComponent };